import { useAccountPicker } from '../account-picker/useAccountPicker';
var TEMPLATES_PICKER_PRESELECTED_TEMPLATE = 'tpTemplate';
var PRESELECTED_TEMPLATE_ID = 'rtb-preselected-template-slug';

function openAppDashboardWithTemplatePicker(templateId, _, workspaceKey) {
  if (!templateId) {
    return;
  }

  window.location.href = "".concat(workspaceKey ? "/s/".concat(workspaceKey) : '', "/app/dashboard/?").concat(TEMPLATES_PICKER_PRESELECTED_TEMPLATE, "=").concat(templateId);
  localStorage.setItem(PRESELECTED_TEMPLATE_ID, templateId);
}

export function useOpenTemplatePicker(templateId, setTemplateId) {
  var callback = function callback(accountId, workspaceKey) {
    return openAppDashboardWithTemplatePicker(templateId, accountId, workspaceKey);
  };

  return useAccountPicker({
    onAccountCancel: function onAccountCancel() {
      return setTemplateId(null);
    },
    onAccountError: function onAccountError() {
      return openAppDashboardWithTemplatePicker(templateId);
    },
    onAccountLoaded: callback,
    onAccountSubmited: callback
  });
}